


































































import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import SettingsInput from '@/components/SettingsInput.vue'
import ConfirmationMessage from '@/components/ConfirmationMessage.vue'
import { Button } from '@alpha/ink'
import api from '@/api'
import store from '@/store'

@Component({
  components: {
    SettingsInput,
    ConfirmationMessage,
    Button
  }
})

export default class PasswordSection extends Vue {
  password: {currentPassword: string, newPassword: string, confirmNewPassword: string} = {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  }

  errors: {currentPassword: boolean, newPassword: boolean, confirmNewPassword: boolean} = {
    currentPassword: false,
    newPassword: false,
    confirmNewPassword: false
  }

  confirmation: {status: boolean, msg: string} = {
    status: false,
    msg: ''
  }

  submitting: boolean = false
  authType: 'password' | 'saml' = 'password'

  get passwordChangeable () {
    return this.authType === 'password'
  }

  async submit () {
    if (!this.validate()) {
      return
    }

    const user = store.state.user.authenticatedUser
    const response = await api.changePassword(user!.uid, {
      oldPassword: this.password.currentPassword,
      newPassword: this.password.newPassword
    })

    if (response.status) {
      this.finish({
        status: 'success',
        msg: 'Password changed.'
      })
    } else {
      this.finish({
        status: 'error',
        msg: response.error
      })
    }
  }

  finish (confirmation:any) {
    this.confirmation = confirmation
    this.submitting = false

    if (confirmation.status !== 'error') {
      setTimeout(() => {
        this.$set(this.confirmation, 'status', false)
      }, 3000)
      // Clear the fields
      this.password.currentPassword = ''
      this.password.newPassword = ''
      this.password.confirmNewPassword = ''
    }
  }

  validate () {
    // check empty currentPassword
    if (this.password.currentPassword.length === 0) {
      this.$set(this.errors, 'currentPassword', 'This is a required field')
    } else {
      this.$set(this.errors, 'currentPassword', false)
    }

    // check empty currentPassword
    if (this.password.newPassword.length === 0) {
      this.$set(this.errors, 'newPassword', 'This is a required field')
    } else {
      this.$set(this.errors, 'newPassword', false)
    }

    // check empty currentPassword
    if (this.password.confirmNewPassword.length === 0) {
      this.$set(this.errors, 'confirmNewPassword', 'This is a required field')
    } else {
      this.$set(this.errors, 'confirmNewPassword', false)
    }

    // Check if it's valid
    if (
      !this.errors.currentPassword &&
    !this.errors.newPassword &&
    !this.errors.confirmNewPassword
    ) {
      if (this.password.newPassword !== this.password.confirmNewPassword) {
        this.$set(this.errors, 'confirmNewPassword', 'Passwords do not match')
      }
      if (
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(
          this.password.newPassword
        )
      ) {
        let passwordMsg = ''
        if (this.password.newPassword.length < 8) {
          passwordMsg += 'Password must be at least 8 characters long<br>'
        }
        if (!/^(?=.*[a-z]).+$/.test(this.password.newPassword)) {
          passwordMsg += 'Password must contain a lowercase letter<br>'
        }
        if (!/^(?=.*[A-Z]).+$/.test(this.password.newPassword)) {
          passwordMsg += 'Password must contain an uppercase letter<br>'
        }
        if (!/^(?=.*\d).+$/.test(this.password.newPassword)) {
          passwordMsg += 'Password must contain a number<br>'
        }
        if (passwordMsg.length > 0) {
          this.$set(this.errors, 'newPassword', passwordMsg)
        }
      }
    }
    return (
      !this.errors.currentPassword &&
    !this.errors.newPassword &&
    !this.errors.confirmNewPassword
    )
  }
}
